var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTree(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "18px",
    viewBox: "0 0 20 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Tree List ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Redesign",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Dashboard",
    transform: "translate(-278.000000, -99.000000)",
    fill: "#C1C4CF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Tree-List-",
    transform: "translate(278.000000, 99.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1,15.5 C0.44771525,15.5 0,15.0528312 0,14.5008931 L0,0.999106914 C0,0.447315402 0.443864822,0 1,0 C1.55228475,0 2,0.447168827 2,0.999106914 L2,4.5 L5,4.5 L5,3.00292933 C5,2.44902676 5.44892021,2 5.99580851,2 L19.0041915,2 C19.5541613,2 20,2.44853006 20,3.00292933 L20,7.99707067 C20,8.55097324 19.5510798,9 19.0041915,9 L5.99580851,9 C5.44583866,9 5,8.55146994 5,7.99707067 L5,6.5 L2,6.5 L2,13.5 L5,13.5 L5,12.0029293 C5,11.4490268 5.44892021,11 5.99580851,11 L19.0041915,11 C19.5541613,11 20,11.4485301 20,12.0029293 L20,16.9970707 C20,17.5509732 19.5510798,18 19.0041915,18 L5.99580851,18 C5.44583866,18 5,17.5514699 5,16.9970707 L5,15.5 L1,15.5 Z M7,16 L18,16 L18,13 L7,13 L7,16 Z M7,7 L18,7 L18,4 L7,4 L7,7 Z",
    id: "Combined-Shape"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTree);
export default __webpack_public_path__ + "static/media/tree.e155af50aa2ec328dfbdd257ce5a5ceb.svg";
export { ForwardRef as ReactComponent };